import type { SentenceResult } from '../api/analysis';

type SentenceHighlightsProps = {
  sentences: SentenceResult[];
};

function rowTone(sentence: SentenceResult): string {
  if (sentence.confidence < 0.35) {
    return 'border-emerald-200 bg-emerald-50';
  }
  if (sentence.confidence < 0.7) {
    return 'border-amber-200 bg-amber-50';
  }
  return 'border-rose-200 bg-rose-50';
}

export function SentenceHighlights({ sentences }: SentenceHighlightsProps) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-teal-700">Sentence Evidence</p>
          <h3 className="mt-2 text-2xl font-semibold text-slate-950">Per-sentence highlight map</h3>
        </div>
        <p className="text-sm text-slate-500">More saturated rows indicate stronger AI-like confidence.</p>
      </div>

      <div className="mt-5 grid gap-3">
        {sentences.map((sentence, index) => (
          <article
            key={`${index}-${sentence.text.slice(0, 20)}`}
            className={`rounded-[1.5rem] border p-4 ${rowTone(sentence)}`}
          >
            <div className="flex flex-wrap items-center justify-between gap-3">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">Sentence {index + 1}</p>
              <div className="flex gap-2 text-sm">
                <span className="rounded-full bg-white/80 px-3 py-1 font-semibold text-slate-900">
                  {sentence.is_ai ? 'AI-like' : 'Human-like'}
                </span>
                <span className="rounded-full bg-white/80 px-3 py-1 font-semibold text-slate-900">
                  {Math.round(sentence.confidence * 100)}%
                </span>
              </div>
            </div>
            <p className="mt-3 text-base leading-7 text-slate-800">{sentence.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
